import { makeAutoObservable, flow, action, observable, runInAction } from 'mobx';
import type { RootStore } from './RootStore';
import { displayErrorMessage } from '../helpers/utils';

export class SpinnerStore {
  @observable isSpinning = false;

  constructor(private rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this, {}, { autoBind: true });
  }

  @action
  showSpinner = () => {
    runInAction(() => {
      this.isSpinning = true;
    });
  };

  @action
  hideSpinner = () => {
    runInAction(() => {
      this.isSpinning = false;
    });
  };

  @flow.bound
  *manageSpinnersHandler(executionFn: () => void) {
    this.showSpinner();
    try {
      yield executionFn();
    } catch (error) {
      displayErrorMessage(error);
    } finally {
      this.hideSpinner();
    }
  }
}
